import type { ReactNode } from 'react';

/**
 * The glass theme's own line icons (Mighty Spatial): 24 grid, round caps and joins, even stroke. The map-tool
 * glyphs are the production theme's repaint of the native controls.
 */
export function LineIcon({
  size = 18,
  stroke = 2.1,
  children,
}: {
  size?: number;
  stroke?: number;
  children: ReactNode;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const GLYPHS = {
  zoomIn: <path d="M12 5.5v13M5.5 12h13" />,
  zoomOut: <path d="M5.5 12h13" />,
  home: (
    <>
      <path d="M4 11.5 12 5l8 6.5" />
      <path d="M6 10.2V19h12v-8.8" />
      <path d="M10 19v-4.6h4V19" />
    </>
  ),
  previous: (
    <>
      <path d="M18 12H6.4" />
      <path d="M11 6.5 5.5 12 11 17.5" />
    </>
  ),
  next: (
    <>
      <path d="M6 12h11.6" />
      <path d="M13 6.5 18.5 12 13 17.5" />
    </>
  ),
  locate: (
    <>
      <circle cx="12" cy="12" r="5.4" />
      <path d="M12 3.6v2.6M12 17.8v2.6M3.6 12h2.6M17.8 12h2.6" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    </>
  ),
  compass: <path d="M12 3.4 17.6 19.6 12 16.6 6.4 19.6z" />,
  chevronLeft: <path d="M15 5l-7 7 7 7" />,
  chevronRight: <path d="M9 5l7 7-7 7" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
} as const;
